<div class="row">
    <div class="offset-md-2 col-md-8">
        <h1 i18n>The page you were looking for doesn't exist :( </h1>
    </div>
</div>
